export default "__VITE_ASSET__M4Yohz6h__"